import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TrackingRecordRegisterDialogComponent } from './tracking-record-register-dialog.ts/tracking-record-register-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSnackBarModule,
    ProgressSpinnerModule,
    TrackingRecordRegisterDialogComponent,
    SharedModule,
  ],
  exports: [TrackingRecordRegisterDialogComponent],
})
export class EntityManagerModule {}
